module.exports = __webpack_public_path__ + "img/marker-icon-2x-orange.1f2da930.png";